import classnames from 'classnames';
const { __ } = wp.i18n;
import renderSVG from "../../../util/RTCLGB-icon-controls/renderIcon"
function Style1(props) {
	const {
		style,
		title,
		currency,
		currency_position,
		price,
		unit,
		badge,
		content_alignment,
		btntext,
		btntype,
		buttonurl,
		page_link,
		button_icon,
		features,
		data,
	} = props;

	const wrapperClass = classnames([
		'rtcl-gb-pricing-box',
		'rtcl-gb-pricing-box-view-' + style,
		'content-alignment-' + content_alignment
	])

	const currencyPositionClass = classnames([
		'rtcl-gb-price',
		'currency-' + currency_position
	])

	return [
		data.length ? (

			<div className={wrapperClass}>

				{badge && (
					<span className="pricing-label">{badge}</span>
				)}

				<div className="pricing-header">
					{title && (
						<h3 className="rtcl-gb-pricing-title">{title}</h3>
					)}
					<div className="rtcl-gb-pricing-price">
						<span className={currencyPositionClass}>
							{currency && (
								<span className="rtcl-gb-pricing-currency">{currency}</span>
							)}
							{price && (
								<span className="rtcl-gb-number">{price}</span>
							)}
						</span>
						{unit && (
							<span className="rtcl-gb-pricing-duration">/ {unit}</span>
						)}
					</div>
				</div>

				<div className="pricing-body">
					<div className="rtcl-gb-pricing-features">
						<ul>
							{features.map((item, index) => (
								<li key={index}>{renderSVG(item.icon)}{item.text}</li>
							))}
						</ul>
					</div>
				</div>

				<div className="pricing-footer">
					{btntext && (
						<div className="rtcl-gb-pricing-button"><a href={btntype === 'page' ? page_link : buttonurl}>{btntext} {button_icon && renderSVG(button_icon)}</a></div>
					)}
				</div>

			</div>

		) : ''
	]
}

export default Style1;